var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"primary-600 pointer no-underline",attrs:{"href":("mailto:" + _vm.SUPPORT_EMAIL)}},[_vm._v("\n  "+_vm._s(_vm.$t('Contact support'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }